var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.78,
    height: 21.65,
    viewBox: "0 0 21.78 21.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-user1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,10.9A10.25,10.25,0,1,1,11.8,21.1,10.24,10.24,0,0,1,1.5,10.9Zm1.5,0a8.8,8.8,0,1,0,8.8-8.8A8.81,8.81,0,0,0,3,10.9Z",
    transform: "translate(-1.4 -0.6)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,21.9l-2-2a.78.78,0,0,1,1.1-1.1l2,2a.78.78,0,0,1,0,1.1.76.76,0,0,1-.5.2C22.1,22.1,21.8,22.1,21.7,21.9Z",
    transform: "translate(-1.4 -0.6)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_112",
    "data-name": "Capa 112"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.2,7.2a3.5,3.5,0,1,1,7,0,3.5,3.5,0,0,1-7,0Zm.9,0a2.6,2.6,0,0,0,5.2,0,2.6,2.6,0,0,0-5.2,0Z",
    transform: "translate(-1.4 -0.6)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,16.3c0-2.1-2.1-3.8-4.8-3.8s-4.8,1.7-4.8,3.8a.54.54,0,0,1-.5.5.54.54,0,0,1-.5-.5c0-2.6,2.5-4.7,5.7-4.7s5.7,2.1,5.7,4.7a.54.54,0,0,1-.5.5C16.5,16.8,16.5,16.6,16.5,16.3Z",
    transform: "translate(-1.4 -0.6)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.4 -0.6)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchUser);
export default __webpack_public_path__ + "static/media/search-user.847f653756a7eba4d9358f9a5cdc9d3f.svg";
export { ForwardRef as ReactComponent };